module.exports = __webpack_public_path__ + "img/logo.ba74d590.webp";